import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { DynamicSelectQuestion } from "../../types";

interface DynamicSelectQuestionProps {
  question: DynamicSelectQuestion;
  value: string;
  onChange: (value: string) => void;
}

export const DynamicSelectQuestionField: React.FC<DynamicSelectQuestionProps> = ({
  question,
  value,
  onChange,
}) => (
  <TextField
    fullWidth
    select
    value={value}
    onChange={(event) => onChange(event.target.value)}
    placeholder={question.placeholder}
    label={question.placeholder || "Select an option"}
  >
    <MenuItem value="">
      {question.placeholder || "Select an option"}
    </MenuItem>
    {question.options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
);
